const { Fragment, useEffect, useState } = wp.element;
const { __ } = wp.i18n;
const { MediaUpload, MediaUploadCheck, URLPopover } = wp.blockEditor;
const { Button, Placeholder, TextControl, Flex } = wp.components;
import H5VP_Video from "../../public/elementor/singleVideo";
import BPlayer from "../../public/BPlayer";
import Player from "../Components/Player";
import BSettings from "./../Components/BSettings";

const H5VP_Video_Obj = new H5VP_Video();

const Edit = (props) => {
  const classes = "h5vp_player ";

  const { attributes, setAttributes, clientId, isSelected } = props;
  // setAttributes({ clientId });
  const {
    controls,
    source,
    poster,
    generatedThumb,
    repeat,
    autoHideControl,
    protected: bProtected,
    overlay,
    streaming,
    streamingType,
    seekTime,
    thumbInPause,
    thumbStyle,
    posterTime,
  } = attributes;

  const [mediaSource, setMediaSource] = useState();
  const [valid, setValid] = useState(true);
  const [player, setPlayer] = useState({});
  const [video, setVideo] = useState({});
  //controls handler
  const controlsHandler = (controls) => {
    const newControls = [];
    Object.keys(controls).map((item, index) => {
      if (controls[item]) {
        newControls.push(item);
      }
    });
    return newControls;
  };

  const infos = {
    provider: "library",
    video: {
      source,
      poster,
    },
    overlay,
    streaming,
    streamingType,
    startTime: 0,
    thumbInPause,
    thumbStyle,
    posterTime,
  };
  const options = {
    controls: controlsHandler(controls),
    clickToPlay: false,
    loop: {
      active: repeat,
    },
    muted: true,
    hideControls: autoHideControl,
    autoplay: false,
    seekTime,
  };

  useEffect(() => {
    if (isSelected) {
      wp.data.dispatch("core/edit-post").openGeneralSidebar("edit-post/block");
    }
  }, [isSelected]);

  useEffect(() => {
    if (source) {
      const videoTag = document.createElement("video");
      videoTag.src = source;
      videoTag.dataset.poster = poster;
      const wrapper = document.querySelector(`#block-${clientId} .h5vp_player`);
      const videoWrapper = document.querySelector(`#block-${clientId} .h5vp_player .videoWrapper`);
      videoWrapper.innerHTML = "";
      videoWrapper.appendChild(videoTag);
      // setPlayer(H5VP_Video_Obj.newVideo(wrapper, options, infos, true));
      const video = new BPlayer(wrapper, options, infos, true);
      setVideo(video);
      window.video = video;
      // console.log({ player });
      // window.video = video;
      // player.volume = 0;
      if (streaming) {
        // player.on("play", function () {
        //   player.pause();
        // });
      }
    }
  }, [source, poster, controls, thumbStyle, autoHideControl, thumbInPause]);

  const handleApply = (event) => {
    event.preventDefault();
    if (!validURL(mediaSource)) {
      setValid(false);
      return false;
    }
    // createVideo();
    setValid(true);
    setAttributes({ source: mediaSource });
    setMediaSource("");
  };

  const validURL = (str) => {
    var pattern = new RegExp("https?", "i"); // fragment locator
    return !!pattern.test(str);
  };

  return (
    <Fragment>
      {source ? (
        <Fragment>
          <BSettings props={props} video={video} />
          <Player classes={classes} attributes={attributes} />
        </Fragment>
      ) : (
        <Fragment>
          <Placeholder
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="html5-block-icon"
              >
                <polygon points="23 7 16 12 23 17 23 7"></polygon>
                <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
              </svg>
            }
            instructions={__("Upload a video or paste/write video url to get started.", "h5vp")}
            label={__("Upload a Video ", "h5vp")}
          >
            {/* <Button isPrimary onClick={() => handleApply()}>
              {__("Video", "h5vp")}
            </Button> */}
            <MediaUploadCheck>
              <MediaUpload
                type={["image"]}
                onSelect={(source) => setAttributes({ source: source.url })}
                render={({ open }) => (
                  <Button isPrimary onClick={open}>
                    {__("Upload", "h5vp")}
                  </Button>
                )}
              />
            </MediaUploadCheck>
            <div className="h5vpUrlInput">
              <h3 style={{ fontSize: "15px" }}> Or </h3>
              <input
                type="url"
                aria-label={__("URL", "h5vp")}
                placeholder={__("Paste or type a video URL", "h5vp")}
                onChange={(src) => {
                  setValid(true);
                  setMediaSource(src.target.value);
                }}
                value={mediaSource}
              />
              <Button label={__("Apply", "h5vp")} type="submit" onClick={handleApply} isPrimary>
                Apply
              </Button>
            </div>
            {!valid && <p style={{ color: "#bd1818", width: "100%", margin: 0 }}>{__("URL is not valid", "h5vp")}</p>}
          </Placeholder>
        </Fragment>
      )}
    </Fragment>
  );
};

export default Edit;
